import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class DirtRoadTileEntity extends TileEntity {
	public static readonly frameName = FrameName.DIRT_ROAD;
}

export default DirtRoadTileEntity;
